import * as types from '~/store/getContent/getContentType';

const initialState = {};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_CONTENT: {
      // console.log(action.type)
      return action.payloads;
    }

    default: {
      return { ...state };
    }
  }
}
